<style lang='less' scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
.selectButtonCon{
    /deep/ .ivu-form-item-content{
        display: flex;
    }
}

.imgCon{
    /deep/ .ivu-form-item-content{
        margin-left: 0 !important;
    }
}


/deep/ .ivu-input-number{
    width: 100% !important;
}

</style>

<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'900px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" style="display:flex">
            
            <div>
                
                <FormItem :label="$t('productManage.addModel.Templet')" prop="tempId" class="ivu-form-item-required selectButtonCon" style="min-width: 420px;">
                    <Input type="text" v-model.trim="formData.basicTypeId" :placeholder="$t('selectPlaceholder')"  disabled></Input>
                    <Button  @click="selectTemplet">{{$t('productManage.addModel.Select_template')}}</Button>
                </FormItem>
                
                <!-- <FormItem :label="$t('BasicProduct.titleName.pageId')" class="ivu-form-item-required" prop="pageId"  style="min-width: 420px;">
                    <Input type="text" v-show="!formData.basicTypeId" :placeholder="'请先'+$t('productManage.addModel.Select_template')"  disabled></Input>
                    <SearchSelect v-show="formData.basicTypeId" ref="pageId" :selectUrlQuery="{basicTypeId:formData.basicTypeId}"  :url="pagesIdListUrl" labelName='pageId'  isMultiple='2'  valName='pageId' labelNameNew="description" keyword="pageId" :labelInValue="true" :placeholderText="type==1?$t('selectPlaceholder'):$t('selectloadingPlaceholder')"  @setSelected="setSelectVal($event,'pageId')"></SearchSelect>
                </FormItem> -->


                <FormItem :label="$t('productManage.addModel.productType')" prop="productType" style="min-width: 420px">
                    <Input type="text" v-model.trim="formData.productType" :placeholder="$t('ruleCustom.productType')" @on-keyup="toUppercase" style="text-transform:uppercase" :disabled='type==2'></Input>
                </FormItem>
    
                <FormItem :label="$t('productManage.addModel.name')" prop="name" class="ivu-form-item-required" style="min-width: 420px">
                    <Input type="text" v-model.trim="formData.name" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>

                 <FormItem :label="$t('productManage.addModel.groupId')" prop="groupId"  style="min-width: 420px">
                    <SearchSelect ref="groupId" :needName="'请先创建'+$t('productManage.ManageGroup')" :url="productsGroupListUrl" labelName='groupName' isMultiple='2'  valName='id' keyword="groupName" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectVal($event,'groupId')"></SearchSelect>
                </FormItem>


                 <FormItem :label="$t('productManage.addModel.normalMode')" prop="normalMode"  style="min-width: 420px">
                    <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.normalMode1" @on-change="changeSelct($event,'normalMode1')" >
                        <Option v-for="(item, index) in selectObj.standardTypeList" :value="item.id" :key="index">{{item['val']}}</Option>
                    </Select>
                </FormItem>

                
                <FormItem   :label="$t('productManage.addModel.aqubeCertify')" prop="aqubeCertify" class="ivu-form-item-required"  style="min-width: 420px">
                    <Select :disabled='roleType==2' :placeholder='$t("selectPlaceholder")' class="input-div" v-model="formData.aqubeCertify1" @on-change="changeSelct($event,'aqubeCertify1')" >
                        <Option v-for="(item, index) in selectObj.standardTypeList" :value="item.id" :key="index">{{item['val']}}</Option>
                    </Select>
                </FormItem>

                 <!-- 分享  -->
                 <!-- roleType==2 && formData.aqubeCertify1==2 -->
                 <FormItem   :label="$t('productManage.addModel.share')" prop="outUsable" class="ivu-form-item-required"  style="min-width: 420px">
                    <Select :placeholder='$t("selectPlaceholder")' class="input-div" v-model="formData.outUsable1" @on-change="changeSelct($event,'outUsable1')" >
                        <Option v-for="(item, index) in selectObj.standardTypeList" :value="item.id" :key="index">{{item['val']}}</Option>
                    </Select>
                </FormItem>


            </div>
           
           <div>
              
                  <FormItem :label="$t('productManage.addModel.marketDate')" prop="marketDate" style="min-width: 420px">
                    <DatePicker :value="formData.marketDate1" type="date"  :placeholder="$t('selectPlaceholder')" @on-change='selectT'  format="yyyy-MM-dd" style="width: 298px"></DatePicker>
                </FormItem>


                 <FormItem :label="$t('productManage.addModel.status')" prop="status"  style="min-width: 420px">
                    <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="formData.status" >
                        <Option v-for="(item, index) in selectObj.StatusList" :value="item.id" :key="index">{{item['val']}}</Option>
                    </Select>
                </FormItem>
    

                <FormItem v-if='roleType==1 || type==2' :label="$t('productManage.addModel.sellUnitPrice')" prop="sellUnitPrice" style="min-width: 420px">
                    <InputNumber  :min="0" v-model="formData.sellUnitPrice" :placeholder="$t('inputPlaceholder')" :disabled='roleType!=1'></InputNumber>
                </FormItem>

                 <FormItem  v-if='roleType==1 || type==2' :label="$t('productManage.addModel.activateUnitPrice')" prop="activateUnitPrice" style="min-width: 420px">
                    <InputNumber  :min="0" v-model="formData.activateUnitPrice" :placeholder="$t('inputPlaceholder')" :disabled='roleType!=1'></InputNumber>
                </FormItem>

    
                <FormItem :label="$t('productManage.addModel.photo')" prop="photo" class="imgCon ivu-form-item-required" style="min-width: 420px;display: flex;align-items: center;">
                    <ImgUpload style="margin-top: 20px" ref="upLogoImg" :action="uploadUsersAvatar" :hasUpload="hasUpload" :num="1"  @setThumbUrl="setThumbUrlthumb"  @removeThumbUrl='removeThumbUrl'></ImgUpload>
                </FormItem>

                <FormItem :label="$t('productManage.addModel.remark')" prop="remark" style="min-width: 420px">
                    <Input  maxlength="100" show-word-limit type="textarea" v-model.trim="formData.remark" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
           </div>
        </Form>

        <div class="flexCC">
          <Button :loading="disabled"  type="primary" @click="subData('formData')" style="marginRight:20px">{{$t('save')}}</Button>
          <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
        </div>


         <!-- 选择模板 -->
        <templetModel :showModel.sync="templetBox.showModel" :fn="templetBox.callbackFn" :tempIdObj.sync='templetBox.tempIdObj'></templetModel>

         <!-- 功能编辑 -->
        <functionModel :showModel.sync="functionBox.showModel" :fn="functionBox.callbackFn" ></functionModel>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import ImgUpload from "@/views/common/upload";
import SearchSelect from '../../common/selectList.vue';
import templetModel from './templetModel.vue';
import functionModel from './functionModel.vue';
import { mapState } from 'vuex'

let uid = sessionStorage.getItem('uInfo')?JSON.parse(sessionStorage.getItem('uInfo')).id:''

    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        components: {
            SearchSelect,
            ImgUpload,
            templetModel,
            functionModel
        },
        data() {
            return {   
                pagesIdListUrl: this.config.urlArray.pagesIdList,//页面编号
                productsGroupListUrl: this.config.urlArray.productsGroupList,//产品分组
                uploadUsersAvatar:this.config.urlArray.uploadImg, //上传图片接口
                hasUpload: [], //已上传图片
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                templetBox:{//规格弹框组-移动
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    tempIdObj:{}
                },
                functionBox:{//规格弹框组-移动
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                },
                formData: {//表单数据
                    dealerId:uid,//经销商编号
                    productType: '',//产品型号
                    marketDate:'',//上市时间
                    marketDate1:'',//上市时间
                    name:'',//产品名称
                    groupId:'',//产品组编号
                    pageId:'',//页面编号
                    normalMode:'',//标准模式，还是阉割模式
                    normalMode1:'',//标准模式，还是阉割模式
                    status:'',//状态1-test 测试阶段，2-bigsale 大卖阶段，3-stopsale停止销售。
                    photo:'', //图片
                    remark:'',//备注
                    basicTypeId:'',//新  基础型号 模板id
                    basicType:'',//基础型号 模板名称
                    aqubeCertify:false,//新 是否通过aqube的认证，认证后可以被其他经销商的客户添加。
                    aqubeCertify1:2,//
                    outUsable:false,//新 分享：如果是，设备可以被别的经销商APP添加使用
                    outUsable1:2,//
                    sellUnitPrice:0,//采购单价，激活单价，超级管理员可以改，经销商只能看
                    activateUnitPrice:0
                },
            }
        },
        watch:{
            showModel(val){
                if(val){
                    
                }
            }
        },
        computed:{
            ...mapState(['local','selectId','uInfo']),
            roleType(){
	        	let res = '2'
	        	if(this.uInfo && this.uInfo.roleType){
	        	 res = this.uInfo.roleType
	        	}
	        	return res
	        },
            selectObj(){
                return {
                    functionCategoryList:[
                        {id: 1,val:this.$t('selectList.functionCategoryList.Water_equipment')},
                        {id: 2,val:this.$t('selectList.functionCategoryList.Raingauge')},
                        {id: 3,val:this.$t('selectList.functionCategoryList.Flowgauge')},
                        {id: 4,val:this.$t('selectList.functionCategoryList.Soil_moisture_detector')},
                    ],
                    connectionTypeList:[
                        {id: 1,val:this.$t('selectList.connectionTypeList.BLE')},
                        {id: 2,val:this.$t('selectList.connectionTypeList.BLEMesh')},
                        {id: 3,val:this.$t('selectList.connectionTypeList.BLE5')},
                        {id: 4,val:this.$t('selectList.connectionTypeList.WIFI')},
                        {id: 5,val:this.$t('selectList.connectionTypeList.LORADTU')},
                        {id: 6,val:this.$t('selectList.connectionTypeList.LORAWan')},
                    ],
                    standardTypeList:[
                        {id: 1,val:this.$t('selectList.standardTypeList.Yes')},
                        {id: 2,val:this.$t('selectList.standardTypeList.No')},
                    ],
                    StatusList:[
                        {id: 1,val:this.$t('selectList.StatusList.Test')},
                        {id: 2,val:this.$t('selectList.StatusList.Big_sale')},
                        {id: 3,val:this.$t('selectList.StatusList.Stop_sale')},
                    ]
 
                }
            },
            ruleCustom(){
                return {
                    productType: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        {pattern: /^[^\u4e00-\u9fa5]+$/, message: this.$t('ruleCustom.productType'), trigger:'blur'}
                    ],
                    name: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    channelNumber: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    // remark: [
                    //     {required: true, message: this.$t('required'),trigger: 'blur' },
                    // ],
                    marketDate: [
                        {required: true, message: this.$t('required'),trigger: 'change',pattern: /.+/ },
                    ],
                    smDeviceType: [
                        {required: true, type:'number', message: this.$t('required'),trigger: 'change' },
                    ],
                    groupId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    pageId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    normalMode: [
                        {required: true, type:'boolean', message: this.$t('required'),trigger: 'change' },
                    ],
                    // aqubeCertify: [
                    //     {required: true, type:'boolean', message: this.$t('required'),trigger: 'change' },
                    // ],
                    baseType: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    macQty: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    status: [
                        {required: true, type:'number', message: this.$t('required'),trigger: 'change' },
                    ],
                    sellUnitPrice: [
                        {required: true, type:'number', message: this.$t('required'),trigger: 'blur' },
                    ],
                    activateUnitPrice: [
                        {required: true, type:'number', message: this.$t('required'),trigger: 'blur' },
                    ],
                    photo: [
                      { required: true, message: this.$t('required'), trigger: 'change' }
                    ]
                }
            }

        },
        created(){
           
        },
        mounted(){
        },
        methods: {
            toUppercase(e){
            //   console.log(e.target._value)
              let value = e.target._value
              this.formData.productType= value.toUpperCase()
            },
            selectTemplet(){//选择模板
                this.templetBox.showModel = true
                this.templetBox.callbackFn = () => {//回调处理
                    this.templetBox.showModel = false;
                    this.formData.basicTypeId= this.templetBox.tempIdObj.id
                    this.formData.pageId = this.templetBox.tempIdObj.pageId+''
                    this.$refs.pageId.setQuery(null)
                    this.$refs.pageId.setDefVal(Number(this.formData.pageId));

                    // console.log(this.templetBox.tempIdObj)
                }
            },
            functionEditor(){//功能编辑
                this.functionBox.showModel = true
                this.functionBox.callbackFn = () => {//回调处理
                    this.functionBox.showModel = false;
                }
            },
            setThumbUrlthumb(item) {//图片上传
              this.formData.photo = item.data;
            },
            removeThumbUrl(){
                this.formData.photo = '';
            },
            selectT(val){
               this.formData['marketDate1'] = val
               this.formData['marketDate'] = new Date(val).getTime()    
                
            },
            setSelectVal(e,key){
                 this.formData[key] = e.nameVal+''
            },
            changeSelct(e,key){
                if(key=='normalMode1' || key=='aqubeCertify1' || key=='outUsable1'){
                    let aaa = key.substring(0,key.length-1)
                    // console.log(aaa)
                    if(e==1){
                        this.formData[aaa] = true
                    }else{
                        this.formData[aaa] = false
                    }
                }
            },
            openOrClose(value) {
                if(value === true) {
                    if(this.type == 2){//编辑表单时，给表单赋值

                        for (let key in this.editFormData) {
                            if (this.formData.hasOwnProperty(key)) {
                                this.formData[key] = this.editFormData[key]
                            }
                        }
                        this.formData.groupId = this.editFormData.groupId + '';
                        this.formData.pageId = this.editFormData.pageId + '';
                        this.formData.normalMode1 = this.editFormData.normalMode?1:2;
                        this.formData.aqubeCertify1 = this.editFormData.aqubeCertify?1:2;
                        this.formData.outUsable1 = this.editFormData.outUsable?1:2;
                        this.formData.marketDate1 = moment(this.editFormData.marketDate*1).format('YYYY-MM-DD');
                        this.formData.activateUnitPrice = this.editFormData.activateUnitPrice*1 //激活单价
                        this.formData.sellUnitPrice = this.editFormData.sellUnitPrice*1 //单价

                        this.$nextTick(()=>{//select赋值，图片赋值
                            this.$refs.groupId.setDefVal(Number(this.formData.groupId));
                            // this.$refs.pageId.setDefVal(Number(this.formData.pageId));

                            let hasUpload1 = [{
                              status:'finished',
                              response:{data:this.formData.photo}
                            }]

                            this.$refs.upLogoImg.setHasUpload(hasUpload1)

                        });
                    }
                    this.$nextTick(()=>{//select赋值，图片赋值
                        this.$refs.groupId.setQuery(null)
                        // if(this.formData.basicTypeId){
                        //     this.$refs.pageId.setQuery(null)
                        // }
                    });
                    this.title = this.type == 1?this.$t('productManage.addModel.title'):this.$t('productManage.editModel.title')
                } else { //关闭弹框后要做的处理
                 
                    this.resetForm();//重置表单
                    this.$refs.groupId.clearVal();
                   if( this.$refs.pageId) this.$refs.pageId.clearVal();
                    this.$refs.upLogoImg.clearImg()
                }
            },
            subData(name) {//提交表单
                // console.log(this.formData)
                // console.log(this.formData.productType.toUpperCase())
                if(!this.formData.basicTypeId){
                    common.msg('error',this.$t('productManage.validateAdd.basicTypeId'))
                    return false
                }
                // if(!this.formData.photo){
                //     common.msg('error',this.$t('productManage.validateAdd.photo'))
                //     return false
                // }



                this.$refs[name].validate((valid) => {
                    if (valid) {

                        let url = ''
                        if (this.type == 2) {
                            this.formData.id = this.editFormData.id
                            url = this.config.urlArray.productsSet
                            
                        }else{
                            url =  this.config.urlArray.productsAdd
                        }  

                        if(this.roleType !=1){//不是超级管理员

                            if(this.type==1 ){
                               this.formData.sellUnitPrice = 0
                               this.formData.activateUnitPrice = 0
                               this.formData.aqubeCertify1 = 2;
                            }

                           if(this.type==2 ){//处于编辑弹框,防止通过更改disabled属性来更改数据
                               this.formData.sellUnitPrice = this.editFormData.sellUnitPrice*1
                               this.formData.activateUnitPrice = this.editFormData.activateUnitPrice*1
                               this.formData.aqubeCertify1 = this.editFormData.aqubeCertify?1:2;
                            }
                           
                        }
                           
                           this.formData.normalMode1==1 ? this.formData.normalMode=true:this.formData.normalMode=false
                           this.formData.aqubeCertify1==1 ? this.formData.aqubeCertify=true:this.formData.aqubeCertify=false
                           this.formData.outUsable1==1 ? this.formData.outUsable=true:this.formData.outUsable=false
                           
                           
                           
                        //    console.log('this.this.formData',this.formData) 
                        

                        // if(this.type==2 && this.roleType !=1){//处于编辑弹框且不是超级管理员,防止通过更改disabled属性来更改数据
                        //    this.formData.sellUnitPrice = this.editFormData.sellUnitPrice*1
                        //    this.formData.activateUnitPrice = this.editFormData.activateUnitPrice*1
                        // }

                        // console.log('this.this.formData',this.formData)  

                        this.disabled = true;
                        this.axios.post(url, {...this.formData,dealerId:this.selectId}).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{
                                this.disabled = false;
                            })
                            
                            
                        }).catch((err) => {
                            this.disabled = false;
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.resetForm();//重置表单
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.formData.aqubeCertify1 = 2
                this.formData.outUsable1 = 2
     
                this.formData.sellUnitPrice = 0
                this.formData.activateUnitPrice = 0
             
                if(this.type == 2){
                    delete this.formData.id
                }
            }
        }
    }
</script>
